module.exports = __webpack_public_path__ + "static/img/step-1021.0064eda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1021.png
// module id = NXdE
// module chunks = 1